const PHOTO_ACTIVITY_TYPES = {
  PHOTO: 'Photo',
  VIDEO: 'Video',
  AUDIO: 'Audio',
}

export default PHOTO_ACTIVITY_TYPES
